
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'ScrollProgress',
  mounted() {
    this.setup()
  },
  beforeDestroy() {
    this.killAnimations()
  },
  methods: {
    setup() {
      /* ScrollTrigger.create({
        id: "scrollProgressPin",
        scroller: document.body,
        trigger: this.$refs.rail,
        endTrigger: this.$el,
        start: "top top",
        end: "bottom center",
        pin: true,
        pinSpacing: false,
      }); */

      ScrollTrigger.create({
        id: 'scrollProgressProgress',
        scroller: document.body,
        trigger: this.$el,
        start: 'top top',
        end: 'bottom bottom',
        scrub: 0.3,

        onUpdate: (self) => {
          const scaleX = self.progress.toFixed(2)
          gsap.to(this.$refs.indicator, {
            scaleX,
            duration: 0.2,
            ease: 'none',
          })
        },
      })
    },
    killAnimations() {
      if (ScrollTrigger.getById('scrollProgressProgress'))
        ScrollTrigger.getById('scrollProgressProgress').kill()
    },
  },
}
